export default "__VITE_ASSET__Dzfkfbtw__"